export default "__VITE_ASSET__Cwf243pS__"